jQuery(document).ready(function () {
    var newWindowWidth = $(window).width();
    if (newWindowWidth < 768) {
        console.log(newWindowWidth);
        jQuery(".event_date_input_icon").click(function () {
            jQuery(this).closest(".event_date_input_wrap").find(".question_mark_details").toggle();
        });
    }

    var dateset, checkSet;
    jQuery(".product-single__meta").click(function (event) { //for listing page
        event.stopPropagation();
        var target = jQuery(event.target);

        if (target.is('#wear-date')) {
            dateset = $(this).attr("data-dateset");
            if (!dateset) {
                dateEventInit(jQuery(this));
            }
            $(this).attr("data-dateset", "yes");
        }

        // checkbox check only one
        if ((target.is(".custom_check_tm")) || (target.is(".custom_check_tm_label"))) {
            checkSet = $(this).attr("data-checkset");
            if (!checkSet) {
                checkBoxInit(jQuery(this));
            }
            $(this).attr("data-checkset", "yes");

            $(this).find(".add-to-cart").addClass("checked");

            // if ($(this).attr("data-checkid")) {
            //     $(this).find(".add-to-cart").addClass("checked");
            //     console.log("checked");
            // } else {
            //     $(this).find(".add-to-cart").removeClass("checked");
            //     console.log("unchecked");
            // }
        }
    });

    function setDateFun(parentSelector, currY, currM, currD, todayDate, selectDateObjTemp) {
        // console.log(currY, selectY);
        // console.log(currM, selectM);
        // console.log(currD, selectD);
        var month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

        var Sminimumweek = jQuery(parentSelector).find("#Sminimumweek");
        var SminimumweekVal = Sminimumweek.val();

        var Smaximumweek = jQuery(parentSelector).find("#Smaximumweek");
        var SmaximumweekVal = Smaximumweek.val();

        var Rminimumweek = jQuery(parentSelector).find("#Rminimumweek");
        var RminimumweekVal = Rminimumweek.val();

        var Rmaximumweek = jQuery(parentSelector).find("#Rmaximumweek");
        var RmaximumweekVal = Rmaximumweek.val();

        var standardMinElem = jQuery(parentSelector).find("#standardMin");
        var standardMaxElem = jQuery(parentSelector).find("#standardMax");
        var rushMinElem = jQuery(parentSelector).find("#rushMin");
        var rushMaxElem = jQuery(parentSelector).find("#rushMax");

        var SminimumweekNum = currD + parseInt(SminimumweekVal);
        var SmaximumweekNum = currD + parseInt(SmaximumweekVal);
        var RminimumweekNum = currD + parseInt(RminimumweekVal);
        var RmaximumweekNum = currD + parseInt(RmaximumweekVal);


        var SminimumweekDate = new Date();
        var SmaximumweekDate = new Date();
        var RminimumweekDate = new Date();
        var RmaximumweekDate = new Date();

        SminimumweekDate.setFullYear(currY, currM, SminimumweekNum);
        SmaximumweekDate.setFullYear(currY, currM, SmaximumweekNum);
        RminimumweekDate.setFullYear(currY, currM, RminimumweekNum);
        RmaximumweekDate.setFullYear(currY, currM, RmaximumweekNum);


        var standardMinD, standardMaxD, rushMinD, rushMaxD;
        standardMinD = SminimumweekDate.getDate();
        standardMaxD = SmaximumweekDate.getDate();
        rushMinD = RminimumweekDate.getDate();
        rushMaxD = RmaximumweekDate.getDate();

        var standardMinMonthNo, standardMaxMonthNo, rushMinMonthNo, rushMaxMonthNo;
        standardMinMonthNo = SminimumweekDate.getMonth();
        standardMaxMonthNo = SmaximumweekDate.getMonth();
        rushMinMonthNo = RminimumweekDate.getMonth();
        rushMaxMonthNo = RmaximumweekDate.getMonth();

        var standardMinMonthName, standardMaxMonthName, rushMinMonthName, rushMaxMonthName;
        standardMinMonthName = month[standardMinMonthNo];
        standardMaxMonthName = month[standardMaxMonthNo];
        rushMinMonthName = month[rushMinMonthNo];
        rushMaxMonthName = month[rushMaxMonthNo];

        var standardMaxYear, rushMaxYear;
        standardMaxYear = SmaximumweekDate.getFullYear();
        rushMaxYear = RmaximumweekDate.getFullYear();

        if (standardMinMonthNo == standardMaxMonthNo) {
            standardMinElem.text(`${standardMinD}`);
        } else {
            standardMinElem.text(`${standardMinD} ${standardMinMonthName}`);
        }
        standardMaxElem.text(`${standardMaxD}  ${standardMaxMonthName} ${standardMaxYear}`);


        if (rushMinMonthNo == rushMaxMonthNo) {
            rushMinElem.text(`${rushMinD}`);
        } else {
            rushMinElem.text(`${rushMinD} ${rushMinMonthName}`);
        }
        rushMaxElem.text(`${rushMaxD}  ${rushMaxMonthName} ${rushMaxYear}`);


        // According to new functionality
        // change message when user select date before rush advised
        let RminimumweekDateTemp = RminimumweekDate;
        RminimumweekDateTemp.setDate(RminimumweekDate.getDate() - 1);
        function onDateChangeShowCheck() {
            var validDateMsg = "Please select a date after today."
            var beforeRushMsg = "You have selected a date before the rush priority delivery date. Please contact us to confirm if delivery is possible before your event date.";
            var currProductMeta, currErrorMsgP;
            currProductMeta = jQuery(parentSelector).closest(".product-single__meta");
            curr_delivery_estimate_box = jQuery(currProductMeta).find(".delivery_estimate_box");
            curr_instock = jQuery(currProductMeta).find(".instock");
            currErrorMsg = jQuery(currProductMeta).find(".errorMsg");
            currSubmitBtn = jQuery(currProductMeta).find(".add-to-cart");
            isDeliveryChecked = jQuery(currProductMeta).attr("data-checkset");
            currErrorMsgP = jQuery(currErrorMsg).find("p");

            if (!jQuery(curr_delivery_estimate_box).hasClass("removeBox")) {
                if (selectDateObjTemp < todayDate) {
                    jQuery(curr_delivery_estimate_box).slideUp();
                    jQuery(currErrorMsgP).text(validDateMsg);
                    jQuery(currErrorMsg).slideDown();
                    jQuery(currSubmitBtn).removeClass("checked");
                } else if ((selectDateObjTemp < RminimumweekDateTemp) && (selectDateObjTemp > todayDate)) {
                    jQuery(curr_delivery_estimate_box).slideDown();
                    jQuery(currErrorMsgP).text(beforeRushMsg);
                    jQuery(currErrorMsg).slideDown();
                    if (isDeliveryChecked) {
                        jQuery(currSubmitBtn).removeClass("checked");
                    } else {
                        jQuery(currSubmitBtn).addClass("checked");
                    }
                } else {
                    jQuery(curr_delivery_estimate_box).slideDown();
                    jQuery(currErrorMsg).slideUp();
                }
            } else {
                jQuery(curr_instock).show();
            }
        }
        onDateChangeShowCheck();
    }

    //on date change
    function dateEventInit(currDateFieldParent) {
        var currTargetVal, selectedDate;
        var eventDate = jQuery(currDateFieldParent).find("#wear-date");

        function setDateMainFun(todayDate, selectDate) {
            var currDate = todayDate.getDate();
            var currMonth = todayDate.getMonth();
            var currYear = todayDate.getFullYear();
            var selectDateObjTemp = new Date(selectDate);
            setDateFun(currDateFieldParent, currYear, currMonth, currDate, todayDate, selectDateObjTemp);
        }

        jQuery(eventDate).change(function () {
            currTargetVal = new Date();
            selectedDate = jQuery(this).val();

            if (selectedDate) {
                setDateMainFun(currTargetVal, selectedDate);
            }
        });
    };

    // checkbox check only one
    function checkBoxInit(parentSelector) {
        // set previous check
        var prevCheck = jQuery(parentSelector).attr("data-checkid");
        if (prevCheck) {
            jQuery(`#${prevCheck}`).prop('checked', true);
        }
        // remove all check and select only one check like radio
        var checkBoxes = jQuery(parentSelector).find(".delivery_estimate_box [type='checkbox']");
        jQuery(checkBoxes).change(function () {
            jQuery(checkBoxes).prop("checked", false);
            jQuery(this).prop("checked", true);
            var currId = jQuery(this).attr("id");
            jQuery(parentSelector).attr("data-checkid", currId);
        });
    }

    // quick-product__btn click
    setTimeout(() => {
        jQuery("[data-section-type='collection-template'] .quick-product__btn").each(function () {
            $(this).click(function () {
                openModalFun();
            });
        });
    }, 2000);
    function openModalFun() {
        setTimeout(() => {
            var allModals = jQuery(".modal");
            if (allModals.hasClass("modal--is-active")) {
                var currActiveModal = jQuery(".modal--is-active");
                var currActiveModalMeta = jQuery(currActiveModal).find(".product-single__meta");
                setEstBoxHTML(currActiveModalMeta);
            }
        }, 2000);
    }

    // Set Estimate Box HTML
    function setEstBoxHTML(currParent) {
        var currEstBox = jQuery(currParent).find(".delivery_estimate_box");
        var currEstBoxInner = jQuery(currEstBox).find(".delivery_estimate_box_inner");
        var currEstBoxTextWrap = jQuery(currEstBoxInner).find(".text_wrap");
        var currEstBoxTextWrapHtml = `<div class="inner">
        <p>
          <input id="standard-fee" type="checkbox" value="no">
          <span class="custom_check_tm"></span>
          <label class="custom_check_tm_label" for="standard-fee">
              <span> Standard Delivery.
              </span>Order Today! Estimated. Ship Date: 
              <b id="standardMin"></b> - <b id="standardMax"></b>
          </label>
        </p><p>
          <input id="rush-fee" type="checkbox" name="attributes[rush-fee]" value="yes">
          <span class="custom_check_tm"></span>
          <label class="custom_check_tm_label" for="rush-fee">
              <span>Rush Priority Delivery $60 fee</span>
              Order Today! Estimated Ship Date:
              <b id="rushMin"></b> - <b id="rushMax"></b>
          </label>
      </p>
    </div>`;

        var allEstBoxes = jQuery(".delivery_estimate_box");
        if (allEstBoxes) {
            $(".delivery_estimate_box .text_wrap .inner").each(function () {
                jQuery(this).remove();
            });
        }
        $(currEstBoxTextWrap).html(currEstBoxTextWrapHtml);
        dateEventInit(currParent);
        checkBoxInit(currParent);
    }

    // modal close button
    setTimeout(() => {
        jQuery("[data-section-type='collection-template'] .modal__close ").each(function () {
            $(this).click(function () {
                closeModalFun();
            });
        });
    }, 2000);
    function closeModalFun() {
        var singleProductWrap = jQuery("#shopify-section-product-template").find(".product-single__meta");;
        setEstBoxHTML(singleProductWrap);
    }




    // Add event listeners to checkboxes
    jQuery(".product-single__meta").click(function (event) { //for listing page
        event.stopPropagation();
        var target = jQuery(event.target);

        if (target.is('.add-to-cart')) {
            if ((target).hasClass("grey_btn")) {
                let checkedVal = jQuery(this).closest(".product-single__meta").find(".delivery_estimate_box [type='checkbox']:checked").closest("p").find('.custom_check_tm_label').text();
                let hidden_delivery_option = jQuery(this).closest(".product-single__meta").find(".deliveryCheckHidden .hidden_delivery_option");
                jQuery(hidden_delivery_option).val(checkedVal);
            }
        }
    });

});